import { HotelSaleModel } from 'api-hooks/sale/hotel';
import { Option } from 'baseui/select';
import { PreferenceFormSchema } from 'common/form-schema';
import * as Yup from 'yup';

export const HotelSaleGuestItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    preferences: Yup.array(PreferenceFormSchema()).default([]),
    isLead: Yup.bool().default(false),

    //additonal information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
    guestPreferences: Yup.array(PreferenceFormSchema()).default([]),
  });

export const HotelSaleHotelItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    checkIn: Yup.date().default(new Date()).nullable(),
    checkOut: Yup.date().default(new Date()).nullable(),
    detail: Yup.string().default(''),
    checkInStatus: Yup.string().nullable().default(null),
    hotelConfirmationCode: Yup.string().default(''),
    night: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    room: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    pax: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    hotelRoomId: Yup.string().default(''),

    //additonal information
    customId: Yup.string(),
    hotelRoomName: Yup.string().default(''),
  });

export const HotelSaleAddOnsItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    guestId: Yup.string().default(''),
    description: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    priceUnit: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    unit: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),

    //additional information
    customId: Yup.string(),
    guestName: Yup.string().default(''),
  });

export const HotelSaleHotelSalesItemFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    bookingCode: Yup.string().default(''),
    hotelId: Yup.string().default(''),
    isCityTax: Yup.boolean().default(false),
    isByPax: Yup.boolean().default(false),
    cityTax: Yup.string().default(''),

    hotelSaleGuests: Yup.array(HotelSaleGuestItemFormSchema()).default([]),
    hotelSaleHotels: Yup.array(HotelSaleHotelItemFormSchema()).default([]),
    hotelSaleAddOns: Yup.array(HotelSaleAddOnsItemFormSchema()).default([]),

    defaultCheckInOut: Yup.object({
      in: Yup.string().default(''),
      out: Yup.string().default(''),
    }),

    //additional information
    customId: Yup.string(),
    hotelName: Yup.string().default(''),
    remark: Yup.string().default(''),
    hotelPhone: Yup.string().default(''),
    hotelEmail: Yup.string().default(''),
    hotelAddress: Yup.string().default(''),
  });

export const HotelSaleFormSchema = () =>
  Yup.object({
    refId: Yup.string(),
    parentRefId: Yup.string(),
    transactionAt: Yup.date().default(new Date()),
    needApproval: Yup.boolean().default(false),
    code: Yup.string().default(''),
    description: Yup.string().default(''),
    adminId: Yup.string().default(''),
    operatorId: Yup.string().default(''),
    salesmanId: Yup.string().default(''),
    customerId: Yup.string().default(''),
    customerBillingId: Yup.string().default(''),
    discount: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    otherCost: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    total: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    hotelSales: Yup.array(HotelSaleHotelSalesItemFormSchema()).default([]),

    //additional information
    tempTransactionAt: Yup.date().default(new Date()),
    phone: Yup.string().default(''),
    address: Yup.string().default(''),
    number: Yup.string().default(''),
    customerStatus: Yup.string().default(''),
    hasDueReceivable: Yup.boolean().default(false),
    remainingTransactionQuota: Yup.number().nullable().default(null),
    isExceedingQuota: Yup.boolean().default(false),
  });
export type HotelSaleGuestItemFormType = Yup.InferType<
  ReturnType<typeof HotelSaleGuestItemFormSchema>
>;

export type HotelSaleHotelItemFormType = Yup.InferType<
  ReturnType<typeof HotelSaleHotelItemFormSchema>
>;

export type HotelSaleAddOnsItemFormType = Yup.InferType<
  ReturnType<typeof HotelSaleAddOnsItemFormSchema>
>;

export type HotelSaleHotelSalesItemFormType = Yup.InferType<
  ReturnType<typeof HotelSaleHotelSalesItemFormSchema>
>;

export type HotelSaleFormType = Yup.InferType<
  ReturnType<typeof HotelSaleFormSchema>
> & {
  hotelSale?: HotelSaleModel;
  customerBillingOptions: Option[];
};
